export enum EditUserInfoRequestStatus {
    Requested = 0,
    Cancelled = 1,
    Rejected = 2,
    Processed = 3
}
